module.exports = __webpack_public_path__ + "static/media/icon-paper-mail.e4c5ab2d.png";